<template>
  <div class="card bg-light mb-2 border-0 p-15">
    <div class="card-body">
      <div class="card-title">
        <div style="margin-left: 40px">
          <div class="row">
            <span>{{ item.claimDocTmplName }}:</span>
            <dir class="col-12">
              <upload :disabled="readonly" :showUpload="true" ref="upload" :sourcetype="3" :sourceId="data.id"
                :autoupload="true" :downloadAll="true" listtype="picture-card">
              </upload>
            </dir>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Upload from "./Upload.vue";
export default {
  components: {
    Upload,
  },
  props: {
    item: Object,
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      data: this.item,
    };
  },
  methods: {
  },
  watch: {
    item() {
      this.data = this.item;

    },
  },
};
</script>

<style lang="scss" scoped>

</style>